<template>
  <div class="artwork-cta">
    <a class="artwork-cta__features-list" :href="borneoPath" @click="trackCTAEvent">
      <div class="artwork-cta__feature">
        <div class="artwork-cta__feature-text">
          <span class="artwork-cta__feature-text-highlight">Free 150,000 Fonts</span>
        </div>
      </div>

      <div class="artwork-cta__feature">
        <UseSvg class="artwork-cta__feature-icon" icon="check-curvy" />
        <div class="artwork-cta__feature-text artwork-cta__feature-text--small">
          Commercial use allowed
        </div>
      </div>
    </a>

    <div class="artwork-cta__intro">
      <div class="artwork-cta__intro-header">
        <div class="artwork-cta__intro-header-first-line">introducing...</div>
        <div class="artwork-cta__intro-header-second-line">
          <UseSvg class="artwork-cta__intro-header-second-line-icon" icon="borneo" />
        </div>
      </div>

      <div class="artwork-cta__intro-upload-file">
        <button-box
          type="button"
          class="artwork-cta__button"
          :href="borneoPath"
          @click="trackCTAEvent"
        >
          Edit your artwork
        </button-box>
      </div>
    </div>
  </div>
</template>

<script>
import { routes } from "jiffy-api";
import { track } from "jiffy-analytics";
import UseSvg from "common/vue/components/UseSvg.vue";
import ButtonBox from "components/jiffy/button-box/ButtonBox.vue";

export default {
  name: "ArtworkCTA",
  components: { UseSvg, ButtonBox },
  props: {
    artworkUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    borneoPath() {
      const borneoPath = routes.borneoRootPath();

      return this.artworkUrl !== ""
        ? `${borneoPath}?borneo_image_url=${encodeURIComponent(this.artworkUrl)}`
        : borneoPath;
    }
  },
  methods: {
    trackCTAEvent() {
      track("borneo_editor_open_button_clicked", { source: "gong_cta" });
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.artwork-cta {
  background: linear-gradient(to right, $borneo-pink-gradient-start, $borneo-pink-gradient-finish);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  gap: 12px;
  padding: 10px 10px 18px 18px;
  margin-top: 10px;
  font-family: sans-serif;

  @include with-large-desktop {
    padding: 15px 15px 25px 25px;
    gap: 18px;
  }

  &__features-list {
    color: $white;
    display: flex;
    flex-direction: column;
    gap: 5px;

    &:hover {
      text-decoration: unset;
      color: $white;
    }
  }

  &__feature {
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 7px;
  }

  &__feature-icon {
    height: 15px;
    width: 15px;
    fill: $white;
    color: $white;

    @include with-large-desktop {
      height: 19px;
      width: 19px;
    }
  }

  &__feature-text {
    font-size: 16px;
    line-height: 1.5;

    @include with-large-desktop {
      font-size: 22px;
    }

    &--small {
      font-size: 12px;
      line-height: 1;

      @include with-large-desktop {
        font-size: 16px;
      }
    }
  }

  &__feature-text-highlight {
    text-transform: uppercase;
  }

  &__intro {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__intro-header {
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: $white;
  }

  &__intro-header-first-line {
    font-weight: 300;
    font-size: 9px;
    line-height: 0.8;

    @include with-large-desktop {
      font-size: 13px;
    }
  }

  &__intro-header-second-line-icon {
    width: 55px;
    height: 13px;

    @include with-large-desktop {
      width: 78px;
      height: 18px;
    }
  }

  &__intro-upload-file {
    width: 100px;

    @include with-large-desktop {
      width: 140px;
    }
  }

  &__button.button-box {
    height: 24px;
    padding: 0;
    border-radius: 6px;
    color: $gray-modern-700;
    background-color: $white;
    font-size: 10px;
    font-weight: 600;
    font-family: sans-serif;
    line-height: 1.4;

    &:focus,
    &:hover {
      background-color: $gray-border;
      color: $gray-modern-700;
    }

    @include with-large-desktop {
      height: 35px;
      font-size: 13px;
    }
  }
}
</style>
